import React from "react";
import {Link, NavLink} from 'react-router-dom';
import LazyLoad from 'react-lazyload';

import {FormatNumber} from "../../Lib/helper";
let stt = 0;

function MovieListComponent (props) {

    if(!props.movieList) {
        return <></>
    }

    const renderItem = () => {

        let colum = 0;
        return props.movieList.map(item => {
            colum ++;
            if(colum > 4) {
                colum = 1;
            }

            return (
                <div className={`col-md-3 col-sm-6 is-colum-${colum}`} key={"moviel-list"+item.id}>
                    <div className="video-item">
                        <div className="item-thumbnail">
                            <NavLink to={`/movie/${item.slug}`} title={item.name}>

                                <LazyLoad >
                                    <img
                                        className="load-delay"
                                        src={item.image}
                                        alt={item.name}
                                        title={item.name}
                                        loading="lazy"
                                        width={262}
                                        height={148}
                                    />
                                </LazyLoad>
                                {/*<img*/}
                                {/*    className="load-delay"*/}
                                {/*    src={item.image}*/}
                                {/*    alt={item.name}*/}
                                {/*    title={item.name}*/}
                                {/*    width={262}*/}
                                {/*    height={148}*/}
                                {/*/>*/}
                                <div className="link-overlay glyphicon glyphicon-play-circle"></div>
                            </NavLink>
                            <span className="duration">{item.duration}</span>
                            {/*<span className="quality">HD</span>*/}
                            <span className="published">{item.published}</span>
                        </div>
                        <div className="item-detail">
                            <h4>
                                <NavLink to={`/movie/${item.slug}`} title={item.name}>
                                    {item.name}
                                </NavLink>

                            </h4>
                            <p>
                                <span>{FormatNumber(item.view)} views</span>
                                <span>&nbsp;&nbsp;</span>
                                <span>{FormatNumber(item.like)} likes</span>
                            </p>
                        </div>
                    </div>
                </div>
            );
        });
    }

    return (
        <div className="movie-list">
            { renderItem()}
        </div>
    )
}

export default MovieListComponent;
